﻿export function setupShareThis() {
    if (window.stLight)
        window.stLight.options({
            publisher: "c6a7cba7-6bcd-4174-b700-bc72df357193",
            doNotHash: false,
            doNotCopy: false,
            hashAddressBar: false
        });
    $(".st_print_custom").click(function () {
        window.print();
    });
}
